/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.wordwrap{word-wrap:break-word}.tinymce-space p{padding:0;margin:1px 0}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Zhci9qZW5raW5zX2hvbWUvd29ya3NwYWNlL0NMQUlNU19QSVBFTElORS9DTE1UTEtfVUlfQVBQX1BJUEVMSU5FL3NyYy9hcHAvY2xtdGxrL3NoYXJlZC9jb21wb25lbnQvbWVzc2FnZS1saXN0L21lc3NhZ2UvbWVzc2FnZS5jb21wb25lbnQuc2Nzcy5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vdmFyL2plbmtpbnNfaG9tZS93b3Jrc3BhY2UvQ0xBSU1TX1BJUEVMSU5FL0NMTVRMS19VSV9BUFBfUElQRUxJTkUvc3JjL2FwcC9jbG10bGsvc2hhcmVkL2NvbXBvbmVudC9tZXNzYWdlLWxpc3QvbWVzc2FnZS9tZXNzYWdlLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/CLAIMS_PIPELINE/CLMTLK_UI_APP_PIPELINE/src/$$_gendir/app/clmtlk/shared/component/message-list/message/message.component.scss.ngstyle.ts